import { AUTHORSEARCH, CATEGORYSEARCH, SEARCH } from "./actionTypes";

export const search = (search_text) => {
  return {
    type: SEARCH,
    payload: search_text,
  };
};

export const category_search = (category) => {
  return {
    type: CATEGORYSEARCH,
    payload: category,
  };
};

export const author_search = (author_name) => {
  return {
    type: AUTHORSEARCH,
    payload: author_name,
  };
};
